import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AttendanceService} from '../../services/attendance.service';
import {NotificationsService} from 'angular4-notifications';
import {BaseComponent} from '../../../application/base.component';
import {AppGlobal} from '../../app.global';
import {Location} from '@angular/common';
import { GlobalFunction } from 'app/common/core/global_function';

@Component({
  selector: 'app-table-display',
  templateUrl: './table-display.component.html',
  styleUrls: ['./table-display.component.scss'],
})
export class TableDisplayComponent extends BaseComponent implements OnInit, OnChanges {

  attendances: any;

  constructor(public router: Router,
              public route: ActivatedRoute,
              public notification_service: NotificationsService,
              private attendance_service: AttendanceService,
              public appGlobal: AppGlobal,
              public _location: Location) {

    super(appGlobal, route, router, _location);
    this.attendances = new AttendanceService(this.attendance_service._db, this.attendance_service.http);
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataList']) {
      this.defaultSort();
    }
  }

  @Input()
  dataList: any[];

  @Input()
  columns: any[];

  @Input()
  actionButtons: any[];

  @Input()
  tableHeader: string;

  @Input()
  displayCounter: boolean = true;

  @Input()
  tableClass: string;

  @Input()
  sectionClass: string = 'supporting-documents';

  @Input()
  wrapTableClass: string;

  @Input()
  primaryField: any;

  @Input()
  fieldName: any;

  @Input()
  additionalKey: any;

  @Input()
  listType: any[];

  @Input()
  studentId: any;

  @Input()
  groupId: any;

  @Input()
  activityStudentDetailTable: boolean = false;

  @Input()
  isRealTimeType: boolean = false;

  @Input()
  isDisableActivityStudentButtonTable: boolean = false;

  @Input()
  activityId: any;

  @Input()
  isSelected: boolean = true;

  @Output('actionAddButton')
  actionAddButton = new EventEmitter<any>();

  @Input()
  labelAddButton: any = '+ Add';

  @Input()
  existAddButton: boolean = false;

  @Input()
  disableAddButton: boolean = false;

  @Output('actionEditButton')
  actionEditButton = new EventEmitter<any>();

  @Input()
  existEditButton: boolean = false;

  @Input()
  disableEditButton: boolean = false;

  @Input()
  labelEditButton: any = 'Edit';

  @Output('actionDeleteButton')
  actionDeleteButton = new EventEmitter<any>();

  @Input()
  existDeleteButton: boolean = false;

  @Input()
  disableDeleteButton: boolean = false;

  @Input()
  labelDeleteButton: any = 'Delete';
  @Input()
  note: any;

  @Input()
  activityStudent: boolean = false;

  /*button activities student detail*/
  @Output('addActivities')
  addActivities = new EventEmitter<any>();

  @Output('addIndividualMentoringActivities')
  addIndividualMentoringActivities = new EventEmitter<any>();

  @Output('editActivities')
  editActivities = new EventEmitter<any>();

  @Output('deleteActivities')
  deleteActivities = new EventEmitter<any>();

  @Output('addAttendancesPresent')
  addAttendancesPresent = new EventEmitter<any>();

  @Output('addAttendancesExcusedAbsent')
  addAttendancesExcusedAbsent = new EventEmitter<any>();

  @Output('addAttendancesUnexcusedAbsent')
  addAttendancesUnexcusedAbsent = new EventEmitter<any>();

  @Output('addAttendancesConnected')
  addAttendancesConnected = new EventEmitter<any>();

  @Output('addAttendancesNoResponse')
  addAttendancesNoResponse = new EventEmitter<any>();

  // status (connection)
  @Output('addStatusConnected')
  addStatusConnected = new EventEmitter<any>();

  @Output('addStatusNoResponse')
  addStatusNoResponse = new EventEmitter<any>();

  @Output('redirectToTrackingChart')
  redirectToTrackingChart = new EventEmitter<any>();

  @Output('actionDeleteStudentFromGroup')
  actionDeleteStudentFromGroup = new EventEmitter<any>();

  @Output()
  selectedRowsChanged = new EventEmitter<any>();

  checkedAll: boolean = false;
  public selectedArr: any[] = [];
  public additionalKeyArr: any[] = [];
  public currentSelected: any;
  public selectedRows: any[] = [];
  public isContainRealTimeType: boolean = false;
  public isContainNonRealTimeType: boolean = false;



  changeSelected(row) {
    let notExist = true;
    let index = -1;
    for(let select of this.selectedArr) {
      index++;
      if (select == row[this.primaryField]) {
        notExist = false;
        this.selectedArr.splice(index, 1);
        this.selectedRows.splice(index, 1);
        row.selected = false;
        break;
      }
    }
    this.currentSelected = row[this.primaryField];
    if (notExist) {
      this.selectedArr.push(row[this.primaryField]);
      this.selectedRows.push(row);
      row.selected = true;
    }

    if(this.activityStudent){

      if(this.selectedArr.length === 0){
        this.isContainNonRealTimeType = false;
        this.isContainRealTimeType = false;
      }else{
        this.handleButtonChange(this.getContactMeanArrBySelectedRows(this.selectedRows));
      }
    }

    if (this.selectedArr.length == this.dataList.length) {
      this.checkedAll = true;
    } else {
      this.checkedAll = false;
    }
    this.selectedRowsChanged.emit(this.selectedRows);
  }

  getContactMeanArrBySelectedRows(selectedArr){
    var contactMeanArr = [];
    selectedArr.forEach(row => {
      contactMeanArr.push(row.contact_means);
    });
    return contactMeanArr;
  }

  handleButtonChange(contactMeansValOrArr){
      var updatedArray = [];
      if(!Array.isArray(contactMeansValOrArr)){
         updatedArray.push(contactMeansValOrArr);
      } else{
        updatedArray = contactMeansValOrArr;
      }


      updatedArray.forEach((val) => {
        const listObj = GlobalFunction.list_contact_means_type.find((obj) => {
          return obj.value === val;
        })
 
        if (listObj !== undefined){
          if(listObj.realTime ){
            this.isContainRealTimeType = true;
          }else{
            this.isContainNonRealTimeType = true;
          }
        }
 
        if(this.isContainRealTimeType && this.isContainNonRealTimeType){
          // Not allow to both type exist
          this.isContainRealTimeType = false;
          this.isContainNonRealTimeType = false;
         return;
       }
     })
  }

  changeCheckAll(){
    if (this.checkedAll) {
      this.selectedArr = [];
      for (let row of this.dataList) {
        this.selectedArr.push(row[this.primaryField]);
        row.selected = true;
      }
      this.selectedRows = this.dataList.slice();
    } else {
      this.selectedArr = [];
      this.selectedRows = [];
      for (let row of this.dataList) {
        row.selected = false;
      }
    }

    if(this.activityStudent){
      this.handleButtonChange(this.getContactMeanArrBySelectedRows(this.selectedRows));
    }

    this.selectedRowsChanged.emit(this.selectedRows);
  }

  public removeSelectedItem(selectedId) {
    let index = -1;
    for (let row of this.dataList) {
      index++;
      if (selectedId == row[this.primaryField]) {
        this.dataList.splice(index, 1);
        break;
      }
    }
    index = -1;
    for (let select of this.selectedArr) {
      index++;
      if (selectedId == select) {
        this.selectedArr.splice(index, 1);
        this.selectedRows.splice(index, 1);
        break;
      }
    }
    if (this.selectedArr.length == 0) {
      this.checkedAll = false;
    } else {
      this.checkedAll = true;
    }

    this.selectedRowsChanged.emit(this.selectedRows);
  }

  public clearSelected(selectedId) {
    let index = -1;
    for (let row of this.dataList) {
      index++;
      if (selectedId == row[this.primaryField]) {
        row.selected = false;
        break;
      }
    }
    index = -1;
    for (let select of this.selectedArr) {
      index++;
      if (selectedId == select) {
        this.selectedArr.splice(index, 1);
        this.selectedRows.splice(index, 1);
        break;
      }
    }
    if (this.selectedArr.length == 0) {
      this.checkedAll = false;
    } else {
      this.checkedAll = true;
    }

    this.selectedRowsChanged.emit(this.selectedRows);
  }

  public removeAllSelectedItem() {
    for(let selectedId of this.selectedArr){
      let index = -1;
      for (let row of this.dataList) {
        index++;
        if (selectedId == row[this.primaryField]) {
          this.dataList.splice(index, 1);
          break;
        }
      }
    }

    this.selectedArr = [];
    this.selectedRows = [];
    this.checkedAll = false;

    this.selectedRowsChanged.emit(this.selectedRows);
  }

  addStudentFromGroup() {
    this.router.navigate(['/' + this.appGlobal.prefixUrlRole + '/group/' + this.groupId + '/activities/' + this.activityId + '/students/add']);
  }

  redirectToPortfolio(){
    this.router.navigate(['/' + this.appGlobal.prefixUrlRole + '/portfolio/student/' + this.currentSelected]);
  }
  redirectToPortfolioFromStudent(){
    this.router.navigate(['/' + this.appGlobal.prefixUrlRole + '/portfolio/student/' + this.studentId]);
  }

  trackingChart() {
    this.router.navigate(['/' + this.appGlobal.prefixUrlRole + '/student/tracking-chart/', this.currentSelected]);
  }

  updateGroupActivityAttendance(status) {
    const selectedArr = this.selectedArr;
    if (!selectedArr || selectedArr.length === 0) {
      return;
    }
    let isAttendanceChangeConfirmed = true;
    if ((/absent|No response/i).test(status)) {
      let isSelectionContainPresentStudent = this.selectedRows.some(activity => {
        return (/present|connected/i).test(activity.status);
      });
      if (isSelectionContainPresentStudent) {
        isAttendanceChangeConfirmed = window.confirm('Existing behavior form of the students will be deleted if the attendance is changed from present to absent. Do you wish to continue?');
      }
    }
    if (!isAttendanceChangeConfirmed) {
      return;
    }

    const that = this;
    for(let selected of selectedArr) {
      that.attendances.updateAttendance(status, this.activityId, selected, this.getAttendanceId(selected)).then(rs => {
        if (!rs.error) {
          that.notification_service.success('Update attendance successfully', '');
          that.updateDisplayAttendance(selected, status);
          that.clearSelected(selected);

        } else {
          that.notification_service.error('Update attendance failed', '');
        }
      });
    }
  }

  getAttendanceId(selected: any) {
    for(let row of this.dataList) {
      if (row['student'] == selected) {
        return row['attendance_id'];
      }
    }
    return '';
  }
  updateDisplayAttendance(selected: any, status) {
    for(let row of this.dataList) {
      if (row['student'] == selected) {
        row['status'] = status;
        break;
      }
    }
  }
  updateDisplayStatus(selected: any, connection) {
    for(let row of this.dataList) {
      if (row['student'] == selected) {
        row['connection'] = connection;
        break;
      }
    }
  }

  defaultSort() {
    if (!this.columns || this.columns.length == 0) {
      return;
    }
    for(let column of this.columns) {
      if (column.defaultSort) {
        this.sortByColumn(column);
        break;
      }
    }
  }

  changeSort(column) {
    if (!column) {
      return;
    }
    column.sort = column.sort == 'asc' ? 'desc' : 'asc';
    this.sortByColumn(column);
  }

  sortByColumn(column) {
    if (!this.dataList || this.dataList.length == 0 || !column) {
      return;
    }

    if (column.sourceSort) {
      if (column.sort == 'asc') {
        this.dataList.sort((a, b) => {
          if (eval('a.' + column.sourceSort) < eval('b.' + column.sourceSort)) return -1;
          else if (eval('a.' + column.sourceSort) > eval('b.' + column.sourceSort)) return 1;
          else return 0;
        });
      } else if (column.sort == 'desc') {
        this.dataList.sort((a, b) => {
          if (eval('a.' + column.sourceSort) > eval('b.' + column.sourceSort)) return -1;
          else if (eval('a.' + column.sourceSort) < eval('b.' + column.sourceSort)) return 1;
          else return 0;
        });
      }

    } else {
      if (column.sort == 'asc') {
        this.dataList.sort((a, b) => {
          if (a[column.source] < b[column.source]) return -1;
          else if (a[column.source] > b[column.source]) return 1;
          else return 0;
        });
      } else if (column.sort == 'desc') {
        this.dataList.sort((a, b) => {
          if (a[column.source] > b[column.source]) return -1;
          else if (a[column.source] < b[column.source]) return 1;
          else return 0;
        });
      }
    }
  }

  actionDeleteButtonClicked() {
    if (confirm('Are you sure to delete the selected records?')) {
      this.actionDeleteButton.emit();
    }
  }

  actionDeleteStudentFromGroupClicked() {
    if (confirm('Are you sure to delete the selected records?')) {
      this.actionDeleteStudentFromGroup.emit();
    }
  }

  deleteActivitiesClicked() {
    if (confirm('Are you sure to delete the selected records?')) {
      this.deleteActivities.emit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/common/component/table-display/table-display.component.ts